<template>
  <div class="RawMaterialDelivery">
    <b-card no-body class="mb-1 mt-2">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button v-b-toggle="'' + uniqueIdentifier" variant="info" style="width: 90%">Produkt {{ rawMaterial.id }}
          <span v-if="rawMaterial.RawMaterialType">
            - {{ rawMaterial.RawMaterialType.name }}
          </span>
          <span v-if="rawMaterial.SerialNumber">| Numer Partii: {{ rawMaterial.SerialNumber }}</span>
        </b-button>
        <span class="float-right" v-on:click="removeItem()">
          <i class="fas fa-trash fa-lg"></i>
        </span>
      </b-card-header>
      <b-collapse :id="uniqueIdentifier" visible :accordion="uniqueIdentifier" role="tabpanel">
        <b-card-body>
          <b-row>
            <b-col sm="12" md="4">
              <validation-provider rules="required" v-slot="{ errors }">
                <label>Surowiec</label>
                <v-select label="name" class="rawMaterialType" :options="products" v-model="rawMaterial.RawMaterialType"></v-select>
                <div v-if="errors.length > 0" class="alert alert-danger">
                  {{ errors[0] }}
                </div>
              </validation-provider>
              <QuickAdd dispatchName="addRawMaterilType" title="Dodaj nowy surowiec"
                description="Nie widzisz surowca na liście? Dodaj go."></QuickAdd>
            </b-col>
            <b-col sm="12" md="4">
              <validation-provider rules="required" v-slot="{ errors }">
                <label>Numer Partii</label>
                <input type="text" class="form-control serialNumber" placeholder="Numer Partii" v-model="rawMaterial.SerialNumber" />
                <div v-if="errors.length > 0" class="alert alert-danger">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </b-col>
            <b-col>
              <b-form-group label="Rodzaj surowca" class="form--label">
                <b-form-radio-group v-model="rawMaterial.ProductType" stacked>
                  <validation-provider v-slot="validationContext" name="Primary Business Type" rules="required">
                    <b-form-radio v-for="option in rawMaterialTypes" :key="option.text" v-model="rawMaterial.ProductType"
                      :state="getValidationState(validationContext)" :value="option.value">
                      {{ option.text }}
                    </b-form-radio>
                    <div v-if="validationContext.length > 0" class="alert alert-danger">
                      {{ validationContext[0] }}
                    </div>
                  </validation-provider>
                </b-form-radio-group>
              </b-form-group>
            </b-col>
            <b-col sm="12" md="6">
              <validation-provider rules="required" v-slot="{ errors }">
                <label>Data ważności</label>
                <b-form-datepicker class="mb-2 validDate" v-model="rawMaterial.RawMaterialExpireDate"></b-form-datepicker>
                <div v-if="errors.length > 0" class="alert alert-danger">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </b-col>
            <b-col sm="12" md="6">
              <validation-provider rules="required" v-slot="{ errors }">
                <label>Kraj pochodzenia surowca</label>
                <v-select label="name" class="country" :options="countries" v-model="rawMaterial.Country"></v-select>
                <div v-if="errors.length > 0" class="alert alert-danger">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="12" md="4">
              <validation-provider rules="required" v-slot="{ errors }">
                <b-form-group label="Rodzaj opakowania">
                  <v-select class="isPackedHermetically" :options="isPackedHermeticallyOptions" :reduce="(x) => x.value"
                    v-model="rawMaterial.IsPackedHermetically"></v-select>
                </b-form-group>
                <div v-if="errors.length > 0" class="alert alert-danger">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </b-col>
            <b-col sm="12" md="4">
              <validation-provider rules="required" v-slot="{ errors }">
                <b-form-group label="Rodzaj materiału opakowania">
                  <v-select class="packageType" :options="packageTypeOptions" :reduce="(x) => x.value"
                    v-model="rawMaterial.PackageType"></v-select>
                </b-form-group>
                <div v-if="errors.length > 0" class="alert alert-danger">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </b-col>
            <b-col sm="12" md="4">
              <validation-provider rules="required" v-slot="{ errors }">
                <b-form-group label="Sposób pakowania">
                  <v-select class="deliveryPackageType" :options="deliveryPackageTypeOptions" :reduce="(x) => x.value"
                    v-model="rawMaterial.DeliveryPackageType"></v-select>
                </b-form-group>
                <div v-if="errors.length > 0" class="alert alert-danger">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="12" md="6">
              <validation-provider rules="required" v-slot="{ errors }">
                <label>Ilość opakowań</label>
                <input type="number" class="form-control numberOfPackages" v-model="rawMaterial.NumberOfPackages" />
                <div v-if="errors.length > 0" class="alert alert-danger">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </b-col>

            <b-col sm="12" md="6">
              <validation-provider rules="required" v-slot="{ errors }">
                <label>Ilość produktów w pudełku</label>
                <input type="number" class="form-control numberOfMaterialsInPackage" v-model="rawMaterial.NumberOfMaterialsInPackage" />
                <div v-if="errors.length > 0" class="alert alert-danger">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </b-col>

            <b-col sm="12" md="6">
              <validation-provider rules="required" v-slot="{ errors }">
                <label>Waga produktu (kg)</label>
                <input type="number" class="form-control rawMaterialWeightInPackage" step="any" v-model="rawMaterial.RawMaterialWeightInPackage" />
                <div v-if="errors.length > 0" class="alert alert-danger">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </b-col>
            <b-col sm="12" md="6">
              <label>Wielkość dostawy w kg:</label>
              <input type="number" class="form-control totalWeight" v-model="totalWeight" disabled />
            </b-col>
            <b-col sm="12" md="6">
              <validation-provider rules="required|min_value:0" v-slot="{ errors }">
                <label>Cena za 1/kg:</label>
                <input type="number" class="form-control pricePerKg" step="0.01" v-model="rawMaterial.pricePerKg"  />
                <div v-if="errors.length > 0" class="alert alert-danger">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </b-col>
          </b-row>

          <b-row class="py-4">
            <b-col>
              <h3>Kontrola jakości</h3>
            </b-col>
          </b-row>

          <DeliveryQuestion @DeliveryQuestionAnswer="recalculateApprovedDecision"
            v-for="item in rawMaterial.deliveryQuestions" :Question="item" :key="item.id">
            {{ rawMaterial.tresc }}
          </DeliveryQuestion>

          <b-row class="mt-2">
            <b-col md="3">
              <validation-provider rules="required" v-slot="{ errors }">
                <b-form-group label="Decyzja o przyjęciu:">
                  <v-select class="isDeliveryApproved" :options="deliveryApproveOptions" :reduce="(x) => x.value"
                    v-model="rawMaterial.IsDeliveryApproved" :disabled="true"></v-select>
                </b-form-group>
                <div v-if="errors.length > 0" class="alert alert-danger">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </b-col>

            <b-col md="5">
              <label>Podjęte działania korygujące w przypadku niezgodności</label>
              <textarea class="form-control deliveryMissMatchComment" v-model="rawMaterial.DeliveryMissMatchComment"></textarea>
            </b-col>
            <b-col md="4">
              <label>Zweryfikowano zgodność certyfikatu</label>
              <textarea class="form-control approvedBy" placeholder="Uwagi" v-model="rawMaterial.ApprovedBy"></textarea>
            </b-col>
          </b-row>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>
<style>
.v-list-item--link::before {
  background-color: red;
}
</style>
<script>
import DeliveryQuestion from "./DeliveryQuestion";
import QuickAdd from "../../Common/QuickAdd";
import ddOptions from "../../../mixins/dropDownOptions";
import deliveryMixins from "../../../mixins/delivery";
import floatHelper from '../../../mixins/floatHelper';

export default {
  name: "RawMaterialDelivery",
  mixins: [ddOptions, deliveryMixins, floatHelper],
  components: { DeliveryQuestion, QuickAdd },
  watch: {
    "rawMaterial.ProductType"(newValue) {
      this.rawMaterial.ApprovedBy = newValue == this.rawMaterialTypeKonwencja ? "Nie dotyczy" : "";
    },
  },
  computed: {
    totalWeight() {
      var data =
        this.rawMaterial.NumberOfPackages *
        (this.rawMaterial.NumberOfMaterialsInPackage *
          this.rawMaterial.RawMaterialWeightInPackage);
      return this.roundTo2(data);
    },
  },
  data() {
    return {
      uniqueIdentifier: "RawMaterial_" + this.rawMaterial.id,
    };
  },
  props: {
    rawMaterial: Object,
    producer: Array,
    countries: Array,
    products: Array,
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    removeItem: function () {
      console.log("clicked");
      this.$emit("removeItem", [this.rawMaterial.id]);
    },
    recalculateApprovedDecision() {
      var that = this;
      const correctAnswers = [true, true, true, true, true, false];
      for (var i = 0; i < this.rawMaterial.deliveryQuestions.length; i++) {
        if (that.rawMaterial.deliveryQuestions[i].isPassed != correctAnswers[i]) {
          that.rawMaterial.IsDeliveryApproved = false;
          return;
        }
      }
      that.rawMaterial.IsDeliveryApproved = true;
      return;
    },
  },
};
</script>
